import React, { useState } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from '../api-constants'
import { useEffect } from 'react'

const NewPassword = () => {

    const search = window.location.search;
    const paramss = new URLSearchParams(search);
    
    const [error, setError] = useState(false)
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [passwordError, setPasswordError] = useState("");
    const [passwordRepeatError, setPasswordRepeatError] = useState("");
    const [noPasswordMatch, setNoPasswordMatch] = useState()
    const [passwordChanged, setPasswordChanged] = useState(false)
    const history = useHistory();
    const [networkError, setNewtorkError] = useState('')

    const [passwordValidationCheck, setPasswordValidationCheck] = useState(false)
    const [isNumber, setIsNumber] = useState(false)
    const [isUppercase, setIsUppercase] = useState(false)
    const [specialCharacter, setSpecialCharacter] = useState(false)
    const [minimum, setMinimum] = useState(false)
 

    useEffect(() => {
       var re = { 'capital': /[A-Z]/ };
       if (re.capital.test(password) === true) {
            setIsUppercase(true)
        }
       else setIsUppercase(false)   
    }, [password])

    useEffect(() => {
        var re = {  'digit': /[0-9]/  };   
        if (re.digit.test(password) === true) setIsNumber(true)
        else setIsNumber(false)    
    }, [password])

    useEffect(() => {
        

        var re = {
            'specialCharacter': /[_!\"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]/ /*/[#?!@$%^&*-]/*/ /*/[#?!@$%^&*-+:.'=><|()"/;`}{`]/*/
           
        }
        
        if (re.specialCharacter.test(password) === true) setSpecialCharacter(true) 
        else setSpecialCharacter(false)      

    }, [password])

  
    useEffect(() => {
        if (password.length > 7) setMinimum(true)
        else setMinimum(false)

    }, [password])


    useEffect(() => {    
        if (isNumber === true && isUppercase === true && specialCharacter === true && minimum === true) {
            setPasswordValidationCheck(false)
        }
    }, [isNumber, isUppercase, specialCharacter, minimum])

    function encodeBase64(str) {
        return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));
    }

    const handleSubmit = (event) => {
        event.preventDefault()
       
        if (password === '' ) {
            setError(true)
            setPasswordError('Udfyld venligst ny adgangskode')
        }
        else if (passwordRepeat === '') {
            setError(true)
            setPasswordRepeatError('Udfyld venligst ny adgangskode igen')

        }
        else if (isNumber === false || minimum === false || isUppercase === false || specialCharacter === false) {   // check if all 4 password validation is aaplied
            setError(true)
            setPasswordError('adgangskode matcher ikke krav')
        }
        else if (password.length && passwordRepeat.length && password !== passwordRepeat) {
            setError(true)
            setNoPasswordMatch('Adgangskode matcher ikke')

        }
        else {
            let email = paramss.get('email')
            let uid = paramss.get('guid')
            let encoded_password = encodeBase64(password)
            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/ResetPassword?Email=${email}&NewPassword=${encoded_password}&guid=${uid}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
            })
                .then((res) => res.json())
                .then((result) => {
                   // console.log(result, 'result')

                    if (result.result === 1) {
                        setPasswordChanged(true)
                        //history.push('/profile', {
                        //    login_info: result.login,
                        //    transaction: result.transactionsPrYear[0],
                        //    newsgroup: result.Newsgroups,
                        //    reservations: result.Reservations,
                        //    key: result.key
                        //})
                    }
                    else {
                        setError(true)
                        setNewtorkError(result.Message)
                    }
                })
           
        }
       
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
        setPasswordError('')
        setError(false)
        setPasswordValidationCheck(true)
       
    }

    const handleRepeatPasswordChange = (e) => {
        setPasswordRepeat(e.target.value)
        setPasswordRepeatError('')
        setError(false)

    }
  
    document.getElementsByTagName('body')[0].style.backgroundColor = 'black'
    return (
        <>

            <div className='login ' style={{ backgroundColor: 'black', padding: '20px 20px 100px 30px ', marginLeft:'-18px' }}>
            <div className='loginflow'  >
                <p className='profile'>Din profil</p>
                {passwordChanged === true ?
                    <p className='emailtext' style={{fontSize:'30px'} }>Din adgangskode er nu opdateret!</p> :
                    <>
            <p className='emailtext'>Indtast ny adgangskode</p>
           

                        <form onSubmit={(e) => handleSubmit(e)} style={{maxWidth:'395px'} } >
                    <label className='email-label'>Ny Adgangskode</label>
                    <input className='email-input' type='password' onChange={handlePasswordChange}></input>
                    {passwordValidationCheck === true ?
                        <div className='password-suggestions'>
                            Password should have:
                            <ul>
                                {minimum          === false ? <li>Minimum of 8 characters</li>       : null}
                                {isUppercase      === false ? <li>At least one uppercase letter</li> : null}
                                {isNumber         === false ? <li>At least one number</li>           : null}
                                {specialCharacter === false ? <li>At least one special character</li>: null}

                            </ul>
                        </div>
                        : null}
                    <label className='email-label'>Gentag ny adgangskode</label>
                    <input type='password' className='email-input' onChange={handleRepeatPasswordChange}></input>
              
          
                    <button type="submit" className='send_btn' >Gem ny adgangskode</button>
                        </form>
                    </>
                }
            {error === true ?
                <div className='error-div'>
                        {networkError && <span>{networkError}</span>}

                        {passwordError &&       <span>{passwordError}</span>}
                        {passwordRepeatError && <span>{passwordRepeatError}</span>}
                        {noPasswordMatch &&     <span>{noPasswordMatch}</span>}
                </div> : null}
            </div>
            </div>      
        </>
            )
}

export default NewPassword